import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { PromotedEventSportSectionWrapper } from './promotedEventsSections/PromotedEventSportSectionWrapper';
import { ListContainer, ListContentWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { EmptyListItem } from 'src/domains/layouts/shared/cms/list/listItems/EmptyListItem';
import { List as MovableList } from 'react-movable';
import { PromotedSportsListState } from 'src/main/cms/PromotedEvents/promotedEventsList/PromotedEventsList.state';

export const PromotedEventsList = observer('PromotedEventsList', () => {
    const {
        cmsState: { promotedEventsState },
        trpcClient,
    } = useAppStateContext();
    const [state] = useState(() => new PromotedSportsListState(trpcClient, promotedEventsState));

    return (
        <ListContainer areLoading={promotedEventsState.isPromotedEventsDataLoading}>
            {promotedEventsState.sportsArray.length === 0 ? (
                <EmptyListItem />
            ) : (
                <MovableList
                    values={promotedEventsState.sportsArray}
                    onChange={state.handleSportsOrder}
                    renderList={({ children, props, isDragged }): React.ReactNode => (
                        <ListContentWrapper
                            {...props}
                            isDragged={isDragged}
                        >
                            {children}
                        </ListContentWrapper>
                    )}
                    renderItem={({ value, props, isDragged }): JSX.Element | null => {
                        return (
                            <div
                                {...props}
                                style={{ ...props.style, zIndex: 'initial' }}
                            >
                                <PromotedEventSportSectionWrapper
                                    key={value.id}
                                    sportData={value}
                                    isDragged={isDragged}
                                />
                            </div>
                        );
                    }}
                />
            )}
        </ListContainer>
    );
});
